const setUser = (email) => {
    localStorage.setItem("user", email);
};
export default setUser